document.addEventListener("DOMContentLoaded", function () {
	const shopTheLookCarousel = document.querySelector(".featured-articles-and-shopthelook__swiper");
	
	if (shopTheLookCarousel) {
		const displayValue = getComputedStyle(shopTheLookCarousel, null).display;

		// TODO: this will cause trouble on resizing window I think - need to change to use same as featured articles
		// * will not run again is needed to 
		if (displayValue == "block") {
			const swiper = new Swiper(".featured-articles-and-shopthelook__swiper", {
				// Optional parameters
				direction: "horizontal",
				loop: true,
				effect: "slide",
				// autoplay: { delay: 5000 },
				speed: 1000,
				keyboard: true,
				centeredSlides: true,
				slidesPerView: 1.5,
				spaceBetween: 15,
				grabCursor: false,
				breakpoints: {
					695: {
						slidesPerView: 2.5,
						spaceBetween: 20,
					},
					610: {
						slidesPerView: 2.5,
						spaceBetween: 20,
					},
					565: {
						slidesPerView: 2.1,
						spaceBetween: 20,
					},
					520: {
						slidesPerView: 2,
						spaceBetween: 20,
					},
					440: {
						slidesPerView: 1.75,
						spaceBetween: 20,
					},
				},
	
				// If we need pagination
				pagination: {
					el: ".swiper-pagination",
				},
	
				// Navigation arrows
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
			});
		}
	}


});
